import React, { useState } from 'react';
import { supabase } from '../lib/supabase';
import { Link } from 'react-router-dom';

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    const { error } = await supabase.auth.resetPasswordForEmail(email);
    setLoading(false);
    if (error) {
      setError(error.message);
    } else {
      setSuccess(true);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-black">
      <div className="bg-white/5 p-8 rounded-lg shadow-xl border border-white/10 w-full max-w-md text-center">
        <h2 className="text-2xl font-bold mb-4 text-white">Reset Password</h2>
        {success ? (
          <>
            <p className="text-green-500 mb-4">If an account exists for that email, a reset link has been sent.</p>
            <Link to="/auth" className="text-white/60 hover:text-white transition-colors">Back to Sign In</Link>
          </>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <input
              type="email"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="Your email address"
              className="w-full px-4 py-2 rounded-lg bg-white/5 border border-white/10 text-white focus:outline-none focus:ring-2 focus:ring-white/25"
              required
            />
            {error && <div className="text-red-500 text-sm bg-red-500/10 p-2 rounded-lg">{error}</div>}
            <button
              type="submit"
              disabled={loading}
              className="w-full py-2 px-4 rounded-lg bg-white/10 hover:bg-white/20 text-white font-medium transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Sending...' : 'Send Reset Link'}
            </button>
            <Link to="/auth" className="block text-white/60 hover:text-white text-sm mt-2">Back to Sign In</Link>
          </form>
        )}
      </div>
    </div>
  );
} 